module.exports = __webpack_public_path__ + "img/rgm-active.9a569e4c.png";